import { FLEX_ARGS, Metadata, pick } from '../../../../utils/spds/metadata';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'CTA button container for the feature banner component',
  extends: [pick(FLEX_ARGS, [{ name: 'gap', default: '16px' }])],
  name: 'Feature Banner CTA Container',
});

export default class SpdsFeedbackFeatureBannerCtaContainer extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-feedback-feature-banner-cta-container';

  get gap() {
    return this.argOrDefault('gap');
  }

  <template>
    <FlexRow
      @gap={{this.gap}}
      class={{this.classes}}
      data-test-spds-feedback-feature-banner-cta-container
      ...attributes
    >
      {{yield}}
    </FlexRow>
  </template>
}

export const FEATURE_BANNER_CTA_CONTAINER_METADATA = SpdsFeedbackFeatureBannerCtaContainer.metadata;
